import { AxiosError } from 'axios';

export const getLocalizedErrorMessage = (error: AxiosError, language: string) => {
    return typeof (error.response?.data as any)?.message === 'string'
        ? (error.response?.data as any)?.message
        : language === 'he'
        ? (error.response?.data as any).message.he
        : (error.response?.data as any).message.en;
};
